<template>
  <div class="condition-prop">
    <template v-if="dataReady">
      <dimension-selector
        v-model="prop"
        :app-id="appId"
        :platform="platform"
        :keyField="keyField"
        :haveUserProp="haveUserProp"
        :haveEventEnv="haveEventEnv"
        :realTimeAble="realTimeAble"
        :width="propWidth"
        :eventIds="eventIds"
        :styleType="styleType"
        :showGroupShortcut="showGroupShortcut"
      ></dimension-selector>
      <c-selector
        v-if="prop"
        class="operate-select"
        :store="operateList"
        placeholder="选择操作符"
        :width="100"
        v-model="operate"
        keyField="value"
        label-field="name"
        @change="onChangeOperator"
      ></c-selector>
      <template v-if="prop">
        <template
          v-if="
            prop.type === 1 &&
              operate.value !== 'is null' &&
              operate.value !== 'is not null'
          "
        >
          <c-selector
            theme="tag"
            :store="propValues"
            :search="onSearch"
            :width="204"
            :maxWidth="204"
            v-model="propValue"
            @change="onChangePropValue"
            multiple
            key-field="value"
            labelField="label"
          >
            <template slot-scope="scope">
              <span :title="scope.data.label">{{
                strMiddleSplit(scope.data.label)
              }}</span>
            </template>
          </c-selector>
        </template>

        <template v-else-if="prop.type === 2">
          <c-input
            v-model="propValue"
            :width="prop.subtype === 2 ? 149 : 204"
            class="number-value"
          ></c-input>
          <span v-if="prop.subtype === 1">%</span>
          <c-selector
            v-if="prop.subtype === 2"
            class="prop-subtype"
            :store="propSubtype"
            :width="50"
            v-model="subtype"
            keyField="value"
            label-field="name"
          ></c-selector>
        </template>

        <template v-else-if="prop.type === 3">
          <c-input
            v-if="operate.value === 'relative'"
            :width="184"
            v-model="propValue"
            class="number-value"
            placeholder="相对时间"
          ></c-input>
          <span v-if="operate.value === 'relative'">天</span>
          <el-date-picker
            v-else
            v-model="propValue"
            type="daterange"
            :editable="false"
            :clearable="false"
            size="small"
            range-separator="~"
            start-placeholder="开始日期"
            :picker-options="shortcuts"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </template>
      </template>
    </template>
    <div style="display: none">{{ output }}</div>
  </div>
</template>

<script>
import DimensionSelector from "../dimensionSelector/index";
import { mapState } from "vuex";
import { actions } from "../../store/constants";
import { util } from "../../utils";
const typeMap = {
  str: 1,
  num: 2,
  date: 3
};
export default {
  name: "conditionItem",
  components: {
    DimensionSelector
  },
  props: {
    /**
     * value = {
     *   isUserProp: false,
     *   isEventProp: false,
     *   isEventEnv: false,
     *   condition: {
     *     attrId: '',
     *     name: '',
     *     type: '',
     *     category: '',
     *     operator: ''
     *   }
     * }
     */
    value: null,
    keyField: {
      type: String,
      default: () => {
        return "value";
      }
    },
    /**
     * @description 如果是事件属性筛选条件，则传事件id,多个用逗号隔开
     */
    eventIds: {
      type: String,
      default: () => {
        return "";
      }
    },
    /**
     * @description 用户属性
     */
    haveUserProp: {
      type: Boolean,
      default: false
    },
    /**
     * @description 事件环境
     */
    haveEventEnv: {
      type: Boolean,
      default: true
    },
    realTimeAble: {
      type: Boolean,
      default: false
    },
    isOld: {
      type: Boolean,
      default: false
    },
    propWidth: {
      type: Number,
      default: 160
    },
    defaultProp: null, // 默认选中的属性
    model: {
      type: String,
      default: () => {
        return "";
      }
    },
    /**
     * 展示分组标题切换标签，快捷展示数据
     */
    showGroupShortcut: {
      type: Boolean,
      default: false
    },
    /**
     * 样式 类型
     */
    styleType: {
      type: String,
      default: ""
    }
  },
  data() {
    let data = {
      dataReady: Boolean(!this.value),
      initValue: this.value,
      operate: null,
      prop: this.defaultProp,
      propValue: null,
      propValues: [],
      propSubtype: [
        {
          name: "时",
          value: "1"
        },
        {
          name: "分",
          value: "2"
        },
        {
          name: "秒",
          value: "3"
        }
      ],
      subtype: {
        value: "1"
      },
      shortcuts: {
        disabledDate(time) {
          let end = new Date().setHours(0, 0, 0, 0);
          let current = time.getTime();
          return current > end;
        }
      }
    };
    return data;
  },
  computed: {
    ...mapState({
      eventList(state) {
        let _eventList = util.clone(sessionStorage.getItem("eventListTemp") ? JSON.parse(sessionStorage.getItem("eventListTemp"))  : state.bizSys.eventList)
        return _eventList.filter(item => {
          return this.eventIdList.includes(item.event_id);
        });
      },
      operateList(state) {
        let list = [];
        if (this.prop) {
          if (this.prop.id == 31415926) {
            list = state.bizCommon.stringBusinessOperate;
          } else if (this.prop.type === typeMap.str) {
            list = state.bizCommon.stringOperate;
          } else if (this.prop.type === typeMap.num) {
            list = state.bizCommon.numberOperate;
          } else if (this.prop.type === typeMap.date) {
            list = state.bizCommon.dateOperate;
          }
          if (!this.operate) {
            this.operate = list[0]; // 如果有值，说明是初始化，那就不需要再赋默认值
          }
        }
        return list;
      },
      userProps(state) {
        let _userProps = sessionStorage.getItem("userPropsTemp") ? JSON.parse(sessionStorage.getItem("userPropsTemp"))  : state.bizSys.userProps
        return _userProps;
      },
      eventEnvs(state) {
        let _eventEnvs = sessionStorage.getItem("eventEnvsTemp") ? JSON.parse(sessionStorage.getItem("eventEnvsTemp"))  : state.bizSys.eventEnvs
        return _eventEnvs;
      },
      ready(state) {
        let readys = state.bizSys.ready;
        let ready = true;
        if (
          (this.haveEventEnv && !readys.eventEnvs) ||
          (this.haveUserProp && !readys.userProps) ||
          (this.eventIdList.length && !readys.eventGroups)
        ) {
          ready = false;
        }
        return ready;
      }
    }),
    eventIdList() {
      if (!this.eventIds) {
        return [];
      } else {
        return this.eventIds.split(",").map(item => {
          return item ? parseInt(item) : item;
        });
      }
    },
    eventAttrList() {
      let result = [];
      this.eventList.forEach(item => {
        window.eventAttrMap[item.event_id].forEach(attr => {
          result.push({
            ...attr,
            event_id: item.event_id,
            event_name: item.event_name
          });
        });
      });
      return result;
    },
    output() {
      if (!this.prop) return;
      if (
        !this.operate ||
        ((!this.propValue || !this.propValue.length) &&
          this.operate &&
          !["is null", "is not null"].includes(this.operate.value))
      ) {
        this.$emit("input", {
          justProp: true
        });
        this.$emit("change", null);
        return null;
      }
      // let _typeMap = {
      //   '1': 'cont-string',
      //   '2': 'cont-num',
      //   '3': 'cont-date'
      // }
      let condition = {
        attrId: this.prop.id,
        name: this.prop.value,
        type: this.prop.type,
        category: this.prop.category || "custom",
        operator: this.operate.value
      };
      if (this.isOld) {
        condition = this.toOld(condition, this.prop);
      }
      switch (this.prop.type) {
        case typeMap.str:
          condition.params = this.propValue
            ? this.propValue.map(item => {
                return item.value;
              })
            : [];
          break;
        case typeMap.date:
          if (this.operate.value === "absolute") {
            condition.params = this.propValue.map(date => {
              return util.dateFormat(date);
            });
          } else {
            condition.params = [this.propValue, "1"];
          }
          break;
        case typeMap.num:
          if (this.prop.subtype === 2) {
            let timeType = {
              "1": 3600,
              "2": 60,
              "3": 1
            };
            let value =
              JSON.parse(this.propValue) * timeType[this.subtype.value];
            condition.params = [value, this.subtype.value];
          } else {
            condition.params = [this.propValue];
          }
          break;
      }
      this.$emit("input", {
        isUserProp: this.prop.isUserProp,
        isEventProp: this.prop.isEventProp,
        isEventEnv: !this.prop.isUserProp && !this.prop.isEventProp,
        condition
      });
      return condition;
    }
  },
  watch: {
    prop(prop, pre) {
      if (
        !prop || // 如果属性置为null ，或者pre为空，但是operate有值（说明是刚开始初始化）
        (!pre && this.operate) ||
        JSON.stringify(prop) === JSON.stringify(pre)
      )
        return;
      if (pre) {
        const keyProps = ["attr_id", "attr_name", "event_id", "type", "id"];
        let isSameProp = true;
        keyProps.forEach(p => {
          if (prop[p] !== pre[p]) isSameProp = false;
        });
        if (isSameProp) return;
      }
      if (prop.type === typeMap.str) {
        this.operate = {
          value: "equal"
        };
        this.propValue = [];
      } else if (prop.type === typeMap.num) {
        this.operate = {
          value: ">"
        };
        this.propValue = "";
      } else if (prop.type === typeMap.date) {
        this.operate = {
          value: "relative"
        };
        this.propValue = "30";
      }
    },
    ready() {
      if (this.ready) {
        this.afterReady();
      }
    }
  },
  beforeMount() {
    if (this.ready) {
      this.afterReady();
    }
    let queryParam = {
      appId: this.appId,
      platform: this.platform
    };
    if (this.haveEventEnv) {
      // 加载事件触发环境数据
      this.$store
        .dispatch(actions.biz.sys.queryEnvMeta, queryParam)
        .then(() => {})
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
    if (this.haveUserProp) {
      // 加载用户属性数据
      this.$store
        .dispatch(actions.biz.sys.queryUserProps, queryParam)
        .then(() => {})
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
    if (this.eventIdList.length) {
      // 加载事件列表数据
      this.$store
        .dispatch(actions.biz.sys.queryEventMeta, queryParam)
        .then(() => {})
        .catch(err => {
          if (err.__CANCEL__) return;
          console.error(err);
        });
    }
  },
  methods: {
    /**
     * @description 因为会需要依赖远程数据，所以需要等数据加载成功后，再进行组件及默认值的初始化
     */
    afterReady() {
      if (!this.ready || !this.initValue) return;
      let prop = null;
      if (this.initValue.isEventEnv) {
        prop = this.eventEnvs.find(item => {
          return item.value === this.initValue.condition.name;
        });
      } else if (this.initValue.isUserProp) {
        // 用户属性需判断category，解决用户自定义属性与内置属性重名
        prop = this.userProps.find(item => {
          return (
            item.value === this.initValue.condition.name &&
            item.category === this.initValue.condition.category
          );
        });
      } else if (this.initValue.isEventProp) {
        prop = this.eventAttrList.find(item => {
          return item.attr_id === this.initValue.condition.attrId;
        });
      }
      if (!prop) return;
      this.prop = prop;
      let operate = this.initValue.condition.operator;
      let params = this.initValue.condition.params;
      this.operate = {
        value: operate
      };
      switch (prop.type) {
        case typeMap.str:
          let list = params.map(val => {
            return {
              value: val,
              label: val
            };
          });
          this.propValues = list;
          this.$nextTick(() => {
            this.propValue = list;
          });
          break;
        case typeMap.date:
          if (operate === "absolute") {
            this.propValue = params.map(value => new Date(value));
          } else {
            this.propValue = params[0];
          }
          break;
        case typeMap.num:
          if (prop.subtype === 2) {
            let timeType = {
              "1": 3600,
              "2": 60,
              "3": 1
            };
            this.subtype = {
              value: params[1]
            };
            this.propValue = params[0] / timeType[params[1]];
          } else {
            this.propValue = params[0];
          }
          break;
        default:
          // eslint-disable-next-line
          console.error("未识别的类型", prop);
      }
      this.dataReady = true;
    },
    validate() {
      let result = {
        valid: true,
        errorMsg: ""
      };
      if (!this.prop) {
        result.valid = false;
        result.errorMsg = "没有选择属性";
        return result;
      }
      if (
        !this.propValue.length &&
        this.operate &&
        !["is null", "is not null"].includes(this.operate.value)
      ) {
        result.valid = false;
        result.errorMsg = "属性值不能为空";
        return result;
      }
      // 数值属性值校验：只能是数字
      if (this.prop && this.prop.type === 2 && isNaN(this.propValue)) {
        result.valid = false;
        result.errorMsg = "属性值错误";
        return result;
      }
      return result;
    },
    strMiddleSplit(str) {
      if (util.isString(str)) {
        return util.strMiddleSplit(str, {
          maxLength: 30,
          beginLength: 12,
          endLength: 15,
          replaceStr: "..."
        });
      }
      return str;
    },
    toOld(condition, prop) {
      let oldData = condition;
      if (prop.isEventProp) {
        oldData.text = prop.alias_name || prop.attr_name;
        oldData.isEventProp = true;
        oldData.eventId = prop.event_id;
        oldData.eventName = prop.event_name;
      } else if (prop.isUserProp) {
        oldData.text = prop.alias_name || prop.text;
        oldData.isUserProp = true;
      } else {
        oldData.text = prop.alias_name || prop.text;
      }
      return oldData;
    },
    onChangeOperator() {
      if (this.prop.type === typeMap.date) {
        if (this.operate.value === "absolute") {
          let oneDate = 24 * 60 * 60 * 1000;
          let end = new Date(new Date().getTime() - oneDate);
          let start = new Date(end - oneDate * 6);
          this.propValue = [start, end];
        } else {
          this.propValue = "30";
        }
      }
    },
    onChangePropValue() {
      this.onSearch();
    },
    onSearch(val) {
      let param = {
        dimensionSub: this.prop.dimension_sub,
        limit: this.propValue.length + 10,
        attr: this.prop.id,
        v: val || "",
        appId: this.appId,
        platform: this.platform
      };
      if (this.model) {
        param.model = this.model;
      }
      return new Promise(resolve => {
        this.$store
          .dispatch(actions.biz.common.queryEsData, param)
          .then(list => {
            let store = [];
            list.forEach(item => {
              store.push({
                label: item,
                value: item
              });
            });
            this.propValues = store;
          })
          .finally(() => {
            resolve();
          });
      });
    }
  }
};
</script>

<style lang="sass">
@import "styles/index"
</style>
